import { PageViewEventLogger } from '@repo/tracking-service';
import { AuthGuard } from '@repo/user-session';
import { useRouter } from 'next/router';
import { ReactElement, useEffect } from 'react';
import { useQueryLoader } from 'react-relay';

import { bznavRefundUserPhoneQuery } from '@/__generated__/bznavRefundUserPhoneQuery.graphql';
import Spinner from '@/components/common/Spinner';
import { SectionScrollModelProvider } from '@/components/common/context/SectionScrollModelProvider';
import Layout from '@/components/layout/Layout';
import { RefundBankAccountContent } from '@/components/tax-refund/bank-account/RefundBankAccountContent';
import { BankAccountContextProvider, BusinessType } from '@/components/tax-refund/bank-account/contexts/bank-account-context';
import { BznavPhoneNumberContextProvider } from '@/components/tax-refund/bank-account/contexts/phone-number-context';
import { bznavRefundUserPhone } from '@/graphql/query/tax-refund/bznav-refund';

function RefundBankAccountPage() {
  const router = useRouter();
  const [queryRef, loadQuery] = useQueryLoader<bznavRefundUserPhoneQuery>(bznavRefundUserPhone);
  const businessType = router.query?.type as BusinessType;
  const pageName = businessType === 'corps' ? 'corps-request' : 'indis-request';

  useEffect(() => {
    loadQuery({});
  }, [loadQuery]);

  if (!businessType) {
    return <Spinner />;
  }

  return (
    <PageViewEventLogger pageName={pageName} eventName={`${pageName}_bankaccount`}>
      <BankAccountContextProvider businessType={businessType}>
        <BznavPhoneNumberContextProvider queryRef={queryRef}>
          <Layout leftIcon={{ icon: 'back', clickEvent: { name: `${pageName}_topnav_back` } }}>
            <RefundBankAccountContent />
          </Layout>
        </BznavPhoneNumberContextProvider>
      </BankAccountContextProvider>
    </PageViewEventLogger>
  );
}

RefundBankAccountPage.getLayout = (page: ReactElement) => {
  return (
    <AuthGuard>
      <SectionScrollModelProvider>{page}</SectionScrollModelProvider>
    </AuthGuard>
  );
};

export default RefundBankAccountPage;
